import React, { forwardRef } from 'react';
import { bool, func, shape, string } from 'prop-types';
import ClassNames from 'classnames';

import Label from '../label/Label';

import './CheckBox.scss';

const CheckBox = forwardRef(
  (
    {
      autoFocus,
      checked,
      className,
      defaultChecked,
      disabled,
      id,
      invalid,
      label,
      name,
      onBlur,
      onChange,
      style
    },
    ref
  ) => {
    const handleChange = event => {
      if (onChange) {
        onChange(event.target.checked);
      }
    };

    return (
      <span className={ClassNames('check-box', { checked })}>
        <input
          aria-invalid={invalid}
          // TODO: Reconsider use of the autoFocus prop.
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={autoFocus}
          checked={checked}
          className={ClassNames('check-box__input', className)}
          defaultChecked={defaultChecked}
          disabled={disabled}
          id={id}
          name={name}
          onBlur={onBlur}
          onChange={handleChange}
          ref={ref}
          style={style}
          type="checkbox"
        />
        <div className="check-box__label-wrap">
          <span className="check-box__box" />
          {label && (
            <Label className="check-box__label --mb-0" htmlFor={id} inline>
              {label}
            </Label>
          )}
        </div>
      </span>
    );
  }
);

CheckBox.propTypes = {
  autoFocus: bool,
  checked: bool,
  className: string,
  defaultChecked: bool,
  disabled: bool,
  id: string,
  invalid: bool,
  label: string,
  name: string,
  onBlur: func,
  onChange: func,
  style: shape({})
};

CheckBox.defaultProps = {
  autoFocus: false,
  checked: undefined,
  className: '',
  defaultChecked: undefined,
  disabled: false,
  id: undefined,
  invalid: false,
  label: '',
  name: '',
  onBlur: () => {},
  onChange: undefined,
  style: {}
};

export default CheckBox;
